import { localStorageSetItem, localStorageGetItem } from "./localStorage"

function generateRandomString(length = 32) {
  return Array.from({ length }, () =>
    "abcdefghijklmnopqrstuvwxyz0123456789".charAt(
      Math.floor(Math.random() * 36)
    )
  ).join("")
}

export default () => {
  window.getPage = function () {
    return window.location.href
      .split("?")[0]
      .split("/")
      .filter((segment) => segment)
      .pop()
  }

  document.addEventListener("DOMContentLoaded", function () {
    let sid = localStorageGetItem("fraud_net_session_id") ?? generateRandomString()

    localStorageSetItem("fraud_net_session_id", sid)

    const fraudNetSettings = document.createElement("script")
    fraudNetSettings.type = "application/json"
    fraudNetSettings.setAttribute("fncls", "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99")
    fraudNetSettings.text = JSON.stringify({
      f: sid,
      s: pipelineConfig.brandCode + "_" + window.getPage(),
    })

    document.body.appendChild(fraudNetSettings)
    const fraudNetScript = document.createElement("script")
    fraudNetScript.src = "https://c.paypal.com/da/r/fb.js"
    document.body.appendChild(fraudNetScript)
  })
}
